<template>
  <div class="admin-wrapper">
    <div class="login-container" v-if="!isLoggedIn">
      <div class="login-box">
        <h1 class="title">Yönetici Girişi</h1>
        <p class="subtitle">Sistem kontrol paneline hoş geldiniz.</p>
        <div class="input-group">
          <input type="email" placeholder="E-Posta Adresi" class="custom-input" v-model="email" />
        </div>
        <div class="input-group">
          <input type="password" placeholder="Şifre" class="custom-input" v-model="password" @keyup.enter="handleLogin" />
        </div>
        <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
        <button type="button" class="login-btn" @click="handleLogin" :disabled="isAuthenticating">
          {{ isAuthenticating ? 'Giriş Yapılıyor...' : 'Giriş Yap' }}
        </button>
      </div>
    </div>

    <div class="dashboard" v-else>
      <div class="sidebar">
        <div class="sidebar-logo-container"><img src="../assets/images/adminlogo.png" alt="BAUMIND Logo" class="sidebar-logo" /></div>
        <ul class="menu">
          <li :class="{ active: activeTab === 'anasayfa' }" @click="activeTab = 'anasayfa'">Ana Sayfa & İletişim</li>
          <li :class="{ active: activeTab === 'kurumsal' }" @click="activeTab = 'kurumsal'">Kurumsal Ayarlar</li>
          <li :class="{ active: activeTab === 'patentler' }" @click="activeTab = 'patentler'">Patentler</li>
          <li :class="{ active: activeTab === 'urunler' }" @click="activeTab = 'urunler'">Ürünler</li>
          <li :class="{ active: activeTab === 'projeler' }" @click="activeTab = 'projeler'">Projeler</li>
          <li :class="{ active: activeTab === 'haberler' }" @click="activeTab = 'haberler'">Haberler</li>
          <li class="logout" @click="handleLogout">Çıkış Yap</li>
        </ul>
      </div>

      <div class="content">
        <!-- ANA SAYFA VE İLETİŞİM -->
        <div v-if="activeTab === 'anasayfa'" class="form-card expanded-card">
          <div class="card-header-fixed"><h2>Ana Sayfa & İletişim Yönetimi</h2></div>
          <div style="display:flex; gap:30px;">
            <div style="flex:1;">
              <div class="input-group"><label>Adres (Yazı Olarak)</label><textarea class="custom-input textarea" rows="3" v-model="formAnasayfa.address"></textarea></div>
              <div class="input-group"><label>Telefon</label><input type="text" class="custom-input" v-model="formAnasayfa.phone" /></div>
              <div class="input-group"><label>E-Posta</label><input type="email" class="custom-input" v-model="formAnasayfa.email" /></div>
              <div class="input-group"><label>LinkedIn Profil URL'si</label><input type="text" class="custom-input" v-model="formAnasayfa.linkedin" placeholder="https://linkedin.com/in/..." /></div>
            </div>
            <div style="flex:1;">
              <div class="input-group"><label>Harita Enlem Değeri (Latitude)</label><input type="text" class="custom-input" v-model="formAnasayfa.lat" placeholder="Örn: 41.0422" /></div>
              <div class="input-group"><label>Harita Boylam Değeri (Longitude)</label><input type="text" class="custom-input" v-model="formAnasayfa.lng" placeholder="Örn: 29.0083" /></div>
              <div style="background-color: #1a1d21; padding: 15px; border-radius: 8px; border: 1px solid #333; margin-top:20px;">
                <h4 style="margin:0 0 10px 0; color:#007bff; font-size:14px;">📍 Koordinatları Nasıl Bulurum?</h4>
                <p style="margin:0; font-size:13px; color:#aaa; line-height:1.5;">
                  1. <a href="https://maps.google.com" target="_blank" style="color:#007bff; text-decoration:none;">Google Haritalar</a>'ı açın ve şirketinizi/konumu bulun.<br>
                  2. İstediğiniz yerin üzerine <b>Sağ Tıklayın</b>.<br>
                  3. Açılan menünün en üstünde yazan sayılara (Örn: 41.04223, 29.00831) tıklayarak kopyalayın.<br>
                  4. İlk sayıyı <b>Enlem</b>, virgülden sonraki ikinci sayıyı <b>Boylam</b> kutusuna yapıştırın.
                </p>
              </div>
            </div>
          </div>
          <button type="button" class="save-btn" style="margin-top:20px;" @click="saveForm('anasayfa')">Tüm İletişim Bilgilerini Güncelle</button>
        </div>

        <!-- KURUMSAL -->
        <div v-if="activeTab === 'kurumsal'" class="form-card expanded-card">
          <div class="card-header-fixed"><h2>Kurumsal Sayfa İçerikleri</h2></div>
          <h3 class="section-title">Biz Kimiz?</h3>
          <div class="input-group"><label>Biz Kimiz Açıklaması (Satır satır)</label><textarea class="custom-input textarea" rows="6" v-model="formKurumsal.bizKimizText"></textarea></div>
          <div class="input-group">
            <label>Biz Kimiz Görseli</label>
            <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'kurumsalBizKimiz')" />
            <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
            <p v-if="formKurumsal.bizKimizImage" class="img-status">✓ Sisteme kayıtlı görsel var.</p>
          </div>
          
          <h3 class="section-title">Hedeflerimiz</h3>
          <div class="input-group"><label>Hedefler (Her hedeften sonra Enter'a basarak alt satıra geçin)</label><textarea class="custom-input textarea" rows="6" v-model="formKurumsal.hedefler"></textarea></div>

          <h3 class="section-title">Misyon & Vizyon</h3>
          <div style="display:flex; gap:20px;">
            <div style="flex:1;"><div class="input-group"><label>Misyonumuz</label><textarea class="custom-input textarea" rows="4" v-model="formKurumsal.misyon"></textarea></div></div>
            <div style="flex:1;"><div class="input-group"><label>Vizyonumuz</label><textarea class="custom-input textarea" rows="4" v-model="formKurumsal.vizyon"></textarea></div></div>
          </div>
          
          <button type="button" class="save-btn" @click="saveForm('kurumsal')" :disabled="isUploading">{{ isUploading ? 'Kaydediliyor...' : 'Tüm Kurumsal Bilgileri Güncelle' }}</button>
        </div>

        <!-- PATENTLER -->
        <div v-if="activeTab === 'patentler'" class="form-card expanded-card">
          <div class="card-header-fixed"><h2>Patent Yönetimi</h2><button type="button" class="toggle-btn" @click="toggleTabVisibility('patentler')">{{ showExistingPatentler ? '+ Yeni Patent Ekle' : 'Mevcutları Gör' }}</button></div>
          <div class="editor-container" v-if="!showExistingPatentler">
            <div class="input-group"><label>Patent Başlığı</label><input type="text" class="custom-input" v-model="formPatentler.title" /></div>
            <div class="input-group"><label>Patent Etiketleri (Listede Gözükür)</label><div style="display:flex; gap:10px;"><input type="text" class="custom-input" placeholder="Örn: Optik" v-model="currentTag" @keyup.enter.prevent="addTag('patentler')" /><button type="button" class="save-btn" style="width: auto; padding: 0 20px;" @click="addTag('patentler')">Ekle</button></div><div class="tags-container" v-if="formPatentler.tags && formPatentler.tags.length > 0"><span class="tag-pill" v-for="(tag, i) in formPatentler.tags" :key="i">{{ tag }} <span class="tag-remove" @click="removeTag('patentler', i)">x</span></span></div></div>
            <div class="input-group"><label>Patent Dış Bağlantısı (Varsa)</label><input type="text" class="custom-input" placeholder="https://..." v-model="formPatentler.link" /></div>
            
            <h3 class="section-title">Patent Detay Şablonu İçerikleri</h3>
            <div style="display:flex; gap:20px;">
              <div style="flex:1;"><div class="input-group"><label>1. Patent Açıklaması</label><textarea class="custom-input textarea" rows="5" v-model="formPatentler.description"></textarea></div></div>
              <div style="flex:1;">
                <div class="input-group">
                  <label>1. Görsel (Varsa)</label>
                  <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'patentImg1')" />
                  <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
                  <p v-if="formPatentler.image" class="img-status">✓ Yüklü</p>
                </div>
              </div>
            </div>
            <div style="display:flex; gap:20px;">
              <div style="flex:1;">
                <div class="input-group">
                  <label>2. Artı Görsel (Varsa)</label>
                  <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'patentImg2')" />
                  <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
                  <p v-if="formPatentler.extraImage" class="img-status">✓ Yüklü</p>
                </div>
              </div>
              <div style="flex:1;"><div class="input-group"><label>2. Artı Açıklama (Varsa)</label><textarea class="custom-input textarea" rows="5" v-model="formPatentler.extraDescription"></textarea></div></div>
            </div>
            <div class="input-group"><label>Teknik Özellikleri (Her maddede Enter'a basın)</label><textarea class="custom-input textarea" rows="5" v-model="formPatentler.techSpecs"></textarea></div>
            
            <button type="button" class="save-btn" @click="saveForm('patentler')" :disabled="isUploading">{{ isUploading ? 'Kaydediliyor...' : 'Kaydet' }}</button>
          </div>
          <div v-else class="existing-list">
             <div class="list-item draggable-item" v-for="(item, index) in existingPatentler" :key="item.id" draggable="true" @dragstart="onDragStart(index)" @dragover.prevent @dragenter.prevent @drop="onDrop(existingPatentler, index)">
              <div class="drag-handle">☰</div><div class="item-info"><strong>{{ item.title }}</strong></div>
              <div class="item-actions"><button type="button" class="edit-btn" @click.stop="handleEdit('patentler', item)">Düzenle</button><button type="button" class="delete-btn" @click.stop="deleteItem('patentler', item.id)">Sil</button></div>
            </div>
          </div>
        </div>

        <!-- ÜRÜNLER -->
        <div v-if="activeTab === 'urunler'" class="form-card expanded-card">
          <div class="card-header-fixed"><h2>Ürün Yönetimi</h2><button type="button" class="toggle-btn" @click="toggleTabVisibility('urunler')">{{ showExistingUrunler ? '+ Yeni Ekle' : 'Mevcutları Gör' }}</button></div>
          <div class="editor-container" v-if="!showExistingUrunler">
            <div class="form-section" style="max-width: 100%;">
              <div class="input-group"><label>Menü İçin Ürün Adı</label><input type="text" class="custom-input" v-model="formUrunler.title" /></div>
              <div class="input-group"><label>Ürün Etiketleri</label><div style="display:flex; gap:10px;"><input type="text" class="custom-input" placeholder="Örn: AR-GE" v-model="currentTag" @keyup.enter.prevent="addTag('urunler')" /><button type="button" class="save-btn" style="width: auto; padding: 0 20px;" @click="addTag('urunler')">Ekle</button></div><div class="tags-container" v-if="formUrunler.tags && formUrunler.tags.length > 0"><span class="tag-pill" v-for="(tag, i) in formUrunler.tags" :key="i">{{ tag }} <span class="tag-remove" @click="removeTag('urunler', i)">x</span></span></div></div>
              <div class="input-group" style="display:flex; align-items:center; gap:10px;">
                <input type="checkbox" id="urunSliderCheck" v-model="formUrunler.showInSlider" style="width: 20px; height: 20px;" />
                <label for="urunSliderCheck" style="margin:0; cursor:pointer;">Bu ürünü ana sayfa slider'ında göster</label>
              </div>
              <div class="input-group" v-if="formUrunler.showInSlider">
                <label>Slider Arka Plan Görseli</label>
                <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'urunSlider')" />
                <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
                <p v-if="formUrunler.sliderImage" class="img-status">✓ Sisteme kayıtlı slider görseli var.</p>
              </div>
              <h3 class="section-title">1. Üst Bölüm (Hero)</h3>
              <div style="display:flex; gap:20px;">
                <div style="flex:1;"><div class="input-group"><label>Sayfa Ana Başlığı</label><input type="text" class="custom-input" v-model="formUrunler.detailTitle" /></div><div class="input-group"><label>Ürün Açıklaması</label><textarea class="custom-input textarea" rows="4" v-model="formUrunler.detailDesc"></textarea></div></div>
                <div style="flex:1;">
                  <div class="input-group">
                    <label>Ana Ürün Görseli</label>
                    <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'urunHero')" />
                    <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
                    <p v-if="formUrunler.heroImage" class="img-status">✓ Yüklü</p>
                  </div>
                </div>
              </div>
              <h3 class="section-title">2. Teknik Özellikler</h3>
              <div style="display:flex; gap:20px;">
                <div style="flex:1;"><div class="input-group"><label>Maddeler</label><textarea class="custom-input textarea" rows="5" v-model="formUrunler.techSpecs"></textarea></div></div>
                <div style="flex:1;">
                  <div class="input-group">
                    <label>Teknik Çizim</label>
                    <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'urunWireframe')" />
                    <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
                    <p v-if="formUrunler.wireframeImage" class="img-status">✓ Yüklü</p>
                  </div>
                </div>
              </div>
              <h3 class="section-title">3. Teknik Parçalar</h3>
              <div style="display:flex; gap:20px;">
                <div style="flex:1; background: #1a1d21; padding: 15px; border-radius: 8px;">
                  <div class="input-group"><label>1. Parça Başlığı</label><input type="text" class="custom-input" v-model="formUrunler.part1Title" /></div>
                  <div class="input-group">
                    <label>Görsel</label>
                    <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'urunPart1')" />
                    <small class="img-info">* En iyi kalite için 1920px genişlik önerilir.</small>
                    <p v-if="formUrunler.part1Image" class="img-status">✓ Yüklü</p>
                  </div>
                </div>
                <div style="flex:1; background: #1a1d21; padding: 15px; border-radius: 8px;">
                  <div class="input-group"><label>2. Parça Başlığı</label><input type="text" class="custom-input" v-model="formUrunler.part2Title" /></div>
                  <div class="input-group">
                    <label>Görsel</label>
                    <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'urunPart2')" />
                    <small class="img-info">* En iyi kalite için 1920px genişlik önerilir.</small>
                    <p v-if="formUrunler.part2Image" class="img-status">✓ Yüklü</p>
                  </div>
                </div>
                <div style="flex:1; background: #1a1d21; padding: 15px; border-radius: 8px;">
                  <div class="input-group"><label>3. Parça Başlığı</label><input type="text" class="custom-input" v-model="formUrunler.part3Title" /></div>
                  <div class="input-group">
                    <label>Görsel</label>
                    <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'urunPart3')" />
                    <small class="img-info">* En iyi kalite için 1920px genişlik önerilir.</small>
                    <p v-if="formUrunler.part3Image" class="img-status">✓ Yüklü</p>
                  </div>
                </div>
              </div>
              <button type="button" class="save-btn" style="margin-top:20px;" @click="saveForm('urunler')" :disabled="isUploading">{{ isUploading ? 'Kaydediliyor...' : 'Kaydet' }}</button>
            </div>
          </div>
          <div v-else class="existing-list">
            <div class="list-item draggable-item" v-for="(item, index) in existingUrunler" :key="item.id" draggable="true" @dragstart="onDragStart(index)" @dragover.prevent @dragenter.prevent @drop="onDrop(existingUrunler, index)"><div class="drag-handle">☰</div><div class="item-info"><strong>{{ item.title }}</strong></div><div class="item-actions"><button type="button" class="edit-btn" @click.stop="handleEdit('urunler', item)">Düzenle</button><button type="button" class="delete-btn" @click.stop="deleteItem('urunler', item.id)">Sil</button></div></div>
          </div>
        </div>

        <!-- PROJELER -->
        <div v-if="activeTab === 'projeler'" class="form-card expanded-card">
          <div class="card-header-fixed"><h2>Proje Yönetimi</h2><button type="button" class="toggle-btn" @click="toggleTabVisibility('projeler')">{{ showExistingProjeler ? '+ Yeni Proje Ekle' : 'Mevcutları Gör' }}</button></div>
          <div class="editor-container" v-if="!showExistingProjeler">
            <div class="form-section">
              <div class="input-group"><label>Proje Adı</label><input type="text" class="custom-input" v-model="formProjeler.title" /></div>
              <div class="input-group"><label>Sayfa Başlığı</label><input type="text" class="custom-input" v-model="formProjeler.detailTitle" /></div>
              <div class="input-group"><label>Proje Etiketleri</label><div style="display:flex; gap:10px;"><input type="text" class="custom-input" placeholder="Örn: İnovasyon, Üretim" v-model="currentTag" @keyup.enter.prevent="addTag('projeler')" /><button type="button" class="save-btn" style="width: auto; padding: 0 20px;" @click="addTag('projeler')">Ekle</button></div><div class="tags-container" v-if="formProjeler.tags && formProjeler.tags.length > 0"><span class="tag-pill" v-for="(tag, i) in formProjeler.tags" :key="i">{{ tag }} <span class="tag-remove" @click="removeTag('projeler', i)">x</span></span></div></div>
              <div class="input-group" style="display:flex; align-items:center; gap:10px;"><input type="checkbox" id="projeSliderCheck" v-model="formProjeler.showInSlider" style="width: 20px; height: 20px;" /><label for="projeSliderCheck" style="margin:0; cursor:pointer;">Bu projeyi ana sayfa slider'ında göster</label></div>
              <div class="input-group" v-if="formProjeler.showInSlider">
                <label>Slider Arka Plan Görseli</label>
                <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'projeSlider')" />
                <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
                <p v-if="formProjeler.sliderImage" class="img-status">✓ Yüklü</p>
              </div>
              <h3 class="section-title">İçerik</h3>
              <div class="input-group"><label>Amacı</label><textarea class="custom-input textarea" rows="4" v-model="formProjeler.detailDesc"></textarea></div>
              <div class="input-group">
                <label>Görsel Seçin</label>
                <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'projeImg')" />
                <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
                <p v-if="formProjeler.imageUrl" class="img-status">✓ Yüklü</p>
              </div>
              <div class="input-group"><label>Özellikler (Satır satır)</label><textarea class="custom-input textarea" rows="6" v-model="formProjeler.techSpecs"></textarea></div>
              <button type="button" class="save-btn" @click="saveForm('projeler')" :disabled="isUploading">{{ isUploading ? 'Kaydediliyor...' : 'Kaydet' }}</button>
            </div>
          </div>
          <div v-else class="existing-list">
             <div class="list-item draggable-item" v-for="(item, index) in existingProjeler" :key="item.id" draggable="true" @dragstart="onDragStart(index)" @dragover.prevent @dragenter.prevent @drop="onDrop(existingProjeler, index)"><div class="drag-handle">☰</div><div class="item-info"><strong>{{ item.title }}</strong></div><div class="item-actions"><button type="button" class="edit-btn" @click.stop="handleEdit('projeler', item)">Düzenle</button><button type="button" class="delete-btn" @click.stop="deleteItem('projeler', item.id)">Sil</button></div></div>
          </div>
        </div>

        <!-- HABERLER -->
        <div v-if="activeTab === 'haberler'" class="form-card expanded-card">
          <div class="card-header-fixed"><h2>Haber Yönetimi</h2><button type="button" class="toggle-btn" @click="toggleTabVisibility('haberler')">{{ showExistingHaberler ? '+ Yeni Haber Ekle' : 'Mevcutları Gör' }}</button></div>
          <div v-if="!showExistingHaberler">
            <div class="input-group"><label>Haber Başlığı</label><input type="text" class="custom-input" v-model="formHaberler.title" /></div>
            <div class="input-group"><label>Haber Etiketleri</label><div style="display:flex; gap:10px;"><input type="text" class="custom-input" v-model="currentTag" @keyup.enter.prevent="addTag('haberler')" /><button type="button" class="save-btn" style="width: auto; padding: 0 20px;" @click="addTag('haberler')">Ekle</button></div><div class="tags-container" v-if="formHaberler.tags && formHaberler.tags.length > 0"><span class="tag-pill" v-for="(tag, i) in formHaberler.tags" :key="i">{{ tag }} <span class="tag-remove" @click="removeTag('haberler', i)">x</span></span></div></div>
            <div class="input-group"><label>Özet / Kalın Giriş Metni</label><textarea class="custom-input textarea" rows="3" v-model="formHaberler.lead"></textarea></div>
            <div class="input-group"><label>Haber İçeriği</label><textarea class="custom-input textarea" rows="8" v-model="formHaberler.content"></textarea></div>
            <div class="input-group">
              <label>Kapak Görseli</label>
              <input type="file" class="custom-file-input" @change="e => onImageSelected(e, 'haberImg')" />
              <small class="img-info">* En iyi kalite için 1920px genişlik önerilir (Boyut fark etmeksizin otomatik optimize edilir).</small>
              <p v-if="formHaberler.image" class="img-status">✓ Yüklü</p>
            </div>
            <button type="button" class="save-btn" @click="saveForm('haberler')" :disabled="isUploading">{{ isUploading ? 'Kaydediliyor...' : 'Kaydet' }}</button>
          </div>
          <div v-else class="existing-list">
             <div class="list-item draggable-item" v-for="(item, index) in existingHaberler" :key="item.id" draggable="true" @dragstart="onDragStart(index)" @dragover.prevent @dragenter.prevent @drop="onDrop(existingHaberler, index)"><div class="drag-handle">☰</div><div class="item-info"><strong>{{ item.title }}</strong></div><div class="item-actions"><button type="button" class="preview-btn" @click.stop="previewItem('news', item.id)">Önizle</button><button type="button" class="edit-btn" @click.stop="handleEdit('haberler', item)">Düzenle</button><button type="button" class="delete-btn" @click.stop="deleteItem('haberler', item.id)">Sil</button></div></div>
          </div>
        </div>

      </div>
    </div>
    <button type="button" class="floating-save-btn" v-if="isListViewActive" @click="saveOrderToFirebase">Sıralamayı Kaydet</button>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue'
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, collection, addDoc, updateDoc, deleteDoc, doc, setDoc, onSnapshot, writeBatch } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged, setPersistence, inMemoryPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app",
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a"
};
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);
const auth = getAuth(app); 

const email = ref(''); const password = ref(''); const errorMessage = ref('');
const isLoggedIn = ref(false); const isAuthenticating = ref(false);
const activeTab = ref('anasayfa'); const isUploading = ref(false);

const showExistingPatentler = ref(false); const showExistingUrunler = ref(false); const showExistingProjeler = ref(false); const showExistingHaberler = ref(false);
const existingPatentler = ref([]); const existingUrunler = ref([]); const existingProjeler = ref([]); const existingHaberler = ref([]);

const formAnasayfa = ref({ address: '', phone: '', email: '', linkedin: '', lat: '', lng: '' })
const formKurumsal = ref({ bizKimizText: '', bizKimizImage: '', hedefler: '', misyon: '', vizyon: '' })
const formPatentler = ref({ id: null, title: '', description: '', image: '', link: '', extraImage: '', extraDescription: '', techSpecs: '', tags: [] })
const formProjeler = ref({ id: null, title: '', detailTitle: '', detailDesc: '', techSpecs: '', imageUrl: '', tags: [], showInSlider: false, sliderImage: '' })
const formHaberler = ref({ id: null, title: '', lead: '', content: '', image: '', tags: [] })
const defaultUrunForm = { id: null, title: '', detailTitle: '', detailDesc: '', techSpecs: '', heroImage: '', wireframeImage: '', part1Title: '', part1Image: '', part2Title: '', part2Image: '', part3Title: '', part3Image: '', tags: [], showInSlider: false, sliderImage: '' }
const formUrunler = ref({ ...defaultUrunForm })

const filesToUpload = ref({});
const currentTag = ref('');

const addTag = (tab) => {
  if (!currentTag.value.trim()) return;
  let targetForm;
  if (tab === 'patentler') targetForm = formPatentler.value;
  else if (tab === 'urunler') targetForm = formUrunler.value;
  else if (tab === 'projeler') targetForm = formProjeler.value;
  else if (tab === 'haberler') targetForm = formHaberler.value;
  if (!targetForm.tags) targetForm.tags = [];
  targetForm.tags.push(currentTag.value.trim());
  currentTag.value = '';
}

const removeTag = (tab, index) => {
  let targetForm;
  if (tab === 'patentler') targetForm = formPatentler.value;
  else if (tab === 'urunler') targetForm = formUrunler.value;
  else if (tab === 'projeler') targetForm = formProjeler.value;
  else if (tab === 'haberler') targetForm = formHaberler.value;
  targetForm.tags.splice(index, 1);
}

const dragIndex = ref(null);
const onDragStart = (index) => { dragIndex.value = index; }
const onDrop = (list, targetIndex) => {
  if (dragIndex.value === null) return;
  const draggedItem = list[dragIndex.value];
  list.splice(dragIndex.value, 1); list.splice(targetIndex, 0, draggedItem); dragIndex.value = null;
}

const isListViewActive = computed(() => {
  return (activeTab.value === 'patentler' && showExistingPatentler.value) || 
         (activeTab.value === 'urunler' && showExistingUrunler.value) || (activeTab.value === 'projeler' && showExistingProjeler.value) || 
         (activeTab.value === 'haberler' && showExistingHaberler.value);
});

const saveOrderToFirebase = async () => {
  let tab = activeTab.value; let currentList = [];
  if (tab === 'patentler') currentList = existingPatentler.value;
  else if (tab === 'urunler') currentList = existingUrunler.value; else if (tab === 'projeler') currentList = existingProjeler.value;
  else if (tab === 'haberler') currentList = existingHaberler.value;
  if (currentList.length === 0) return;
  try {
    const batch = writeBatch(db);
    currentList.forEach((item, index) => { batch.update(doc(db, tab, item.id), { order: index }); });
    await batch.commit(); alert("Sıralama başarıyla kaydedildi!");
  } catch (error) { alert("Hata: " + error.message); }
}

const setupRealtimeListener = (collectionName, stateRef) => {
  onSnapshot(collection(db, collectionName), (snapshot) => {
    const dataList = [];
    snapshot.forEach((doc) => { dataList.push({ id: doc.id, ...doc.data() }); });
    dataList.sort((a, b) => { return (a.order !== undefined ? a.order : 9999) - (b.order !== undefined ? b.order : 9999); });
    stateRef.value = dataList;
  });
}

onMounted(() => {
  onAuthStateChanged(auth, (user) => { isLoggedIn.value = !!user; });
  
  onSnapshot(doc(db, "ayarlar", "anasayfa"), (docSnap) => { 
    if (docSnap.exists()) {
      const data = docSnap.data();
      formAnasayfa.value = { ...data, lat: data.lat || '', lng: data.lng || '' }; 
    }
  });

  onSnapshot(doc(db, "ayarlar", "kurumsal"), (docSnap) => { if (docSnap.exists()) formKurumsal.value = docSnap.data(); });
  setupRealtimeListener("patentler", existingPatentler); setupRealtimeListener("urunler", existingUrunler);
  setupRealtimeListener("projeler", existingProjeler); setupRealtimeListener("haberler", existingHaberler);
})

const handleEdit = (tab, item) => {
  if (tab === 'patentler') { formPatentler.value = { ...item }; if(!formPatentler.value.tags) formPatentler.value.tags = []; showExistingPatentler.value = false; }
  else if (tab === 'urunler') { formUrunler.value = { ...item }; if(!formUrunler.value.tags) formUrunler.value.tags = []; if(formUrunler.value.showInSlider === undefined) formUrunler.value.showInSlider = false; showExistingUrunler.value = false; }
  else if (tab === 'projeler') { formProjeler.value = { ...item }; if(!formProjeler.value.tags) formProjeler.value.tags = []; if(formProjeler.value.showInSlider === undefined) formProjeler.value.showInSlider = false; showExistingProjeler.value = false; }
  else if (tab === 'haberler') { formHaberler.value = { ...item }; if(!formHaberler.value.tags) formHaberler.value.tags = []; showExistingHaberler.value = false; }
}

const deleteItem = async (tab, id) => { if (confirm('Emin misiniz?')) { try { await deleteDoc(doc(db, tab, String(id))); } catch (error) {} } }

const toggleTabVisibility = (tab) => {
  currentTag.value = ''; filesToUpload.value = {};
  if (tab === 'patentler') { showExistingPatentler.value = !showExistingPatentler.value; if (!showExistingPatentler.value) formPatentler.value = { id: null, title: '', description: '', image: '', link: '', extraImage: '', extraDescription: '', techSpecs: '', tags: [] } } 
  else if (tab === 'urunler') { showExistingUrunler.value = !showExistingUrunler.value; if (!showExistingUrunler.value) formUrunler.value = { ...defaultUrunForm } } 
  else if (tab === 'projeler') { showExistingProjeler.value = !showExistingProjeler.value; if (!showExistingProjeler.value) formProjeler.value = { id: null, title: '', detailTitle: '', detailDesc: '', techSpecs: '', imageUrl: '', tags: [], showInSlider: false, sliderImage: '' } } 
  else if (tab === 'haberler') { showExistingHaberler.value = !showExistingHaberler.value; if (!showExistingHaberler.value) formHaberler.value = { id: null, title: '', lead: '', content: '', image: '', tags: [] } }
}

const onImageSelected = (event, key) => { if (event.target.files[0]) filesToUpload.value[key] = event.target.files[0]; }

// DÜZELTİLDİ: TÜM YÜKLEMELER İÇİN MAKSİMUM KALİTE & 1920PX ÇÖZÜNÜRLÜK (FULL HD)
const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) return resolve(null); 
    const reader = new FileReader(); reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image(); img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas'); 
        let width = img.width, height = img.height;
        
        // Sınırı 1200'den 1920'ye çıkardık
        if (width > 1920) { 
            height = Math.round((height * 1920) / width); 
            width = 1920; 
        }
        
        canvas.width = width; 
        canvas.height = height;
        const ctx = canvas.getContext('2d'); 
        
        // Tarayıcıya görseli çizerken keskinliği en üst düzeyde tutmasını söylüyoruz
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        
        ctx.drawImage(img, 0, 0, width, height);
        
        // Kalite oranını %80'den %95'e çıkardık.
        resolve(canvas.toDataURL('image/webp', 0.95));
      };
      img.onerror = () => reject(new Error("Görsel okunamıyor."));
    };
    reader.onerror = () => reject(new Error("Yükleme hatası."));
  });
};

const saveForm = async (tab) => {
  if (tab === 'anasayfa') { 
    try { await setDoc(doc(db, "ayarlar", "anasayfa"), formAnasayfa.value); alert("Ana sayfa ve iletişim bilgileri güncellendi!"); } catch (error) { alert(error.message); }
    return; 
  }
  
  if (tab === 'kurumsal') {
    isUploading.value = true;
    try {
      let data = { ...formKurumsal.value };
      if (filesToUpload.value['kurumsalBizKimiz']) { data.bizKimizImage = await compressImage(filesToUpload.value['kurumsalBizKimiz']); filesToUpload.value['kurumsalBizKimiz'] = null; }
      await setDoc(doc(db, "ayarlar", "kurumsal"), data);
      alert("Kurumsal içerikler başarıyla güncellendi!");
    } catch (error) { alert(error.message); } finally { isUploading.value = false; }
    return;
  }

  let currentForm = {}; let stateRef = null;
  if (tab === 'patentler') { currentForm = formPatentler.value; stateRef = existingPatentler; }
  else if (tab === 'urunler') { currentForm = formUrunler.value; stateRef = existingUrunler; }
  else if (tab === 'projeler') { currentForm = formProjeler.value; stateRef = existingProjeler; }
  else if (tab === 'haberler') { currentForm = formHaberler.value; stateRef = existingHaberler; }

  const dataToSave = { ...currentForm }; delete dataToSave.id;
  isUploading.value = true;
  try {
    if (tab === 'patentler') {
      if (filesToUpload.value['patentImg1']) dataToSave.image = await compressImage(filesToUpload.value['patentImg1']);
      if (filesToUpload.value['patentImg2']) dataToSave.extraImage = await compressImage(filesToUpload.value['patentImg2']);
    }
    if (tab === 'projeler') {
      if (filesToUpload.value['projeImg']) dataToSave.imageUrl = await compressImage(filesToUpload.value['projeImg']);
      if (filesToUpload.value['projeSlider']) dataToSave.sliderImage = await compressImage(filesToUpload.value['projeSlider']);
    }
    if (tab === 'haberler' && filesToUpload.value['haberImg']) dataToSave.image = await compressImage(filesToUpload.value['haberImg']);
    if (tab === 'urunler') {
      const imgTypes = ['urunHero', 'urunWireframe', 'urunPart1', 'urunPart2', 'urunPart3', 'urunSlider'];
      for (let key of imgTypes) { if (filesToUpload.value[key]) { let dbKey = key.replace('urun',''); dbKey = dbKey.charAt(0).toLowerCase() + dbKey.slice(1) + 'Image'; dataToSave[dbKey] = await compressImage(filesToUpload.value[key]); } }
    }
    if (currentForm.id) { await updateDoc(doc(db, tab, currentForm.id), dataToSave); } 
    else { dataToSave.order = stateRef.value.length || 0; await addDoc(collection(db, tab), dataToSave); }
    toggleTabVisibility(tab);
  } catch (error) { alert("Hata: " + error.message); } finally { isUploading.value = false; }
}

watch(activeTab, () => { showExistingPatentler.value = false; showExistingUrunler.value = false; showExistingProjeler.value = false; showExistingHaberler.value = false; currentTag.value = ''; filesToUpload.value = {}; })

const handleLogin = async () => { 
  if (!email.value || !password.value) return errorMessage.value = 'Lütfen bilgileri girin.';
  isAuthenticating.value = true; errorMessage.value = '';
  try { await setPersistence(auth, inMemoryPersistence); await signInWithEmailAndPassword(auth, email.value, password.value); } 
  catch (error) { errorMessage.value = 'Hatalı giriş!'; } finally { isAuthenticating.value = false; }
}

const handleLogout = async () => { try { await signOut(auth); } catch (error) { console.error(error); } }
</script>

<style scoped>
.admin-wrapper { background-color: #0d0d0d; min-height: 100vh; font-family: 'Segoe UI', sans-serif; color: #fff; margin: 0; padding: 0; }
.login-container { display: flex; align-items: center; justify-content: center; min-height: 100vh; }
.login-box { background-color: #1a1a1a; padding: 40px; border-radius: 16px; width: 100%; max-width: 380px; text-align: center;}
.login-btn, .save-btn { padding: 14px; border-radius: 8px; border: none; background-color: #007bff; color: white; cursor: pointer; width: 100%; }
.login-btn:disabled, .save-btn:disabled { background-color: #0056b3; cursor: not-allowed; opacity: 0.7; }
.dashboard { display: flex; height: 100vh; overflow: hidden; }
.sidebar { width: 260px; background-color: #141414; padding: 30px 20px; border-right: 1px solid #2a2a2a; }
.sidebar-logo { max-width: 100%; height: auto; }
.menu { list-style: none; padding: 0; }
.menu li { padding: 15px; margin-bottom: 10px; cursor: pointer; color: #ccc; }
.menu li.active { background-color: #007bff; color: #fff; }
.content { flex: 1; padding: 50px; background-color: #0a0a0a; overflow-y: auto; }
.form-card { background-color: #141414; padding: 40px; border-radius: 12px; border: 1px solid #2a2a2a; max-width: 800px; margin: 0 auto; }
.expanded-card { max-width: 1300px; }
.card-header-fixed { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #2a2a2a; padding-bottom: 15px; margin-bottom: 25px; }
.card-header-fixed h2 { margin: 0; font-size: 24px; font-weight: normal;}
.toggle-btn { background-color: #333; color: #fff; border: 1px solid #555; padding: 8px 16px; border-radius: 6px; cursor: pointer; transition: 0.2s;}
.toggle-btn:hover { background-color: #444; }
.input-group { margin-bottom: 20px; }
.custom-input { width: 100%; padding: 12px; border-radius: 8px; border: 1px solid #333; background-color: #1e1e1e; color: #fff; }
.custom-file-input { color: #ccc; }
.existing-list { display: flex; flex-direction: column; gap: 15px; }
.list-item { display: flex; justify-content: space-between; align-items: center; background-color: #1e1e1e; padding: 15px; border-radius: 8px; }
.item-actions { display: flex; gap: 8px; }
.preview-btn { background-color: #17a2b8; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; }
.edit-btn { background-color: #ffc107; color: black; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; }
.delete-btn { background-color: #dc3545; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; }
.floating-save-btn { position: fixed; bottom: 30px; right: 40px; background-color: #ff9800; color: white; border: none; padding: 15px 25px; border-radius: 30px; cursor: pointer; }
.section-title { color: #007bff; margin-top: 40px; margin-bottom: 15px; border-bottom: 1px solid #2a2a2a; padding-bottom: 8px;}
.img-status { color: #28a745; font-size: 12px; }
.tags-container { margin-top: 10px; display: flex; gap: 8px; flex-wrap: wrap; }
.tag-pill { background-color: #333; border: 1px solid #555; color: white; padding: 5px 12px; border-radius: 20px; font-size: 13px; display: flex; align-items: center; gap: 8px; }
.tag-remove { cursor: pointer; color: #ff6b6b; }
.img-info { color: #aaa; font-size: 12px; display: block; margin-top: 6px; font-style: italic; }
</style>